module.exports = __webpack_public_path__ + "media/binaryto.ffcf7b4b.mp4";